import React, {Component} from 'react'
import {Link} from 'react-router-dom'

class NoMatch extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        return (
            <div className="content">
                <div className="main-content error404">
                    <div className="inner">
                        <h2 className="error mx-auto" data-text="404">404</h2>
                        <p className="lead text-gray-800 mb-5">Page Not Found</p>
                        <p className="text-gray-500 mb-0">It looks like you found a glitch in the
                            matrix...</p>
                        <Link to="/dashboard">&larr; Back to Dashboard</Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default NoMatch